import React from 'react';
import { withRouter } from 'react-router-dom';
import { withApollo } from "react-apollo";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { deleteComment } from '../../graphql/mutations';
import { commentFeed, comment } from '../../graphql/queries';


class CommentDelete extends React.Component {

	constructor(props) {
		super(props);

		this.handleDelete = this.handleDelete.bind(this);
	}

	handleDelete() {

		const isDetail = (this.props.match.path === '/channels/:id/post/:id_2');
		const isDetailDelete = (isDetail && this.props.match.params.id_2 === this.props.commentId);

		const qlVars = {id: this.props.commentId};
		const qlVarsComment = {id: this.props.match.params.id_2};
	
		if(window.confirm('delete post?')) {

			const refetchQueries = [];
			refetchQueries.push({
				query: commentFeed,
				variables: { filter: { channel: this.props.match.params.id }, cursor: '' }
			});
			
			if(isDetail && !isDetailDelete) {
				refetchQueries.push({
					query: comment,
					variables: qlVarsComment
				});
			}

			this.props.client.mutate({
				mutation: deleteComment,
				variables: qlVars,
				refetchQueries
			})
			.then(res => {
				if(isDetailDelete) this.props.history.replace('/channels/' + this.props.match.params.id);
			})
		}
	}

	render() {

		let className = 'button';
		if(this.props.buttonClass) className += ' ' + this.props.buttonClass;
		const label = this.props.label ? ' ' + this.props.label : '';

		return (
			<button onClick={this.handleDelete} className={className} title="delete comment">
				<FontAwesomeIcon icon="trash" />{label}
			</button>
		)
	}
}


export default withRouter(withApollo(CommentDelete))


// WEBPACK FOOTER //
// ./src/components/comment/CommentDelete.js